import { ACTION_TAG_WATERMARK } from 'components/molecules/LexicalEditor/plugins/ActionPicker/components/CreateActionPopup';

export function isCreatingAction(id?: string) {
  return document.getElementById(ACTION_TAG_WATERMARK + id) !== null;
}
